import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import HomePage3 from "../HomePage3/HomePage3";
import AboutUsPage from "../AboutUsPage/AboutUsPage";
import ContactPage from "../ContactPage/ContactPage";
import Terms from "../TermsPage/Terms/Terms";

import { Toaster } from "react-hot-toast";
import Loader from "../../components/Loader/Loader";

/* =========================================
   ROUTE CHANGE LOADER
========================================= */
const RouteChangeLoader = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 400);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return loading ? <Loader /> : null;
};

/* =========================================
   ALL ROUTES
========================================= */
const AllRoute = () => {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: { fontSize: "15px", fontWeight: 500 },
          success: { style: { background: "#0f172a", color: "#fff" } },
          error: { style: { background: "#7f1d1d", color: "#fff" } },
        }}
      />

      <BrowserRouter>
        <RouteChangeLoader />

        <Routes>
          {/* ================= CORE ================= */}
          <Route path="/" element={<HomePage3 />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* ================= GENERAL BUSINESS POLICIES ================= */}
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/privacy-policy" element={<Terms />} />
          <Route path="/cookie-policy" element={<Terms />} />
          <Route path="/payment-portal-terms" element={<Terms />} />
          <Route path="/fraudulent-communications" element={<Terms />} />
          <Route path="/email-pseudonym-policy" element={<Terms />} />

          {/* ================= CONFERENCE POLICIES ================= */}
          <Route path="/conference-privacy-policy" element={<Terms />} />
          <Route path="/conference-terms-conditions" element={<Terms />} />
          <Route path="/code-of-conduct" element={<Terms />} />
          <Route path="/media-partnership-terms" element={<Terms />} />

          {/* ================= FALLBACK ================= */}
          <Route path="*" element={<HomePage3 />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
